/**
 * BusquedaGrupo Component - Asistencias
 * 
 * Componente para buscar grupos por campus y fecha.
 * Muestra tabla de resultados con grupos disponibles.
 * Integrado con APIs del backend (reutiliza endpoints de calificaciones).
 * 
 * Basado en Image 18 del diseño
 */

import React, { useState, useEffect } from "react";
import styles from "./RegistroAsistencias.module.css";
import { getGruposAsesor } from "../../api/asistencias";
import { getCampusDisponibles } from "../../api/calificaciones";

function BusquedaGrupo({ onSeleccionarGrupo, infoAsesor, infoUsuario }) {
  // Eliminado filtro de campus
  // Eliminada sincronización de campus seleccionado
  const [fecha, setFecha] = useState(() => {
    // Fecha por defecto: hoy en formato YYYY-MM-DD
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [busqueda, setBusqueda] = useState('');
  const [grupos, setGrupos] = useState([]);
  const [loading, setLoading] = useState(false);
  // Eliminado estado de campusOptions y loadingCampus
  const [errorMessage, setErrorMessage] = useState('');

  // Eliminado efecto de carga de campus

  // Cargar grupos cuando hay asesor disponible
  useEffect(() => {
    if (infoAsesor?.id_asesor) {
      handleBuscar();
    }
  }, [infoAsesor]);

  const handleBuscar = async () => {
    // Verificar que tenemos un asesor
    if (!infoAsesor?.id_asesor) {
      setErrorMessage('No se detectó un asesor asociado a este usuario. Solo los asesores pueden ver sus grupos.');
      setGrupos([]);
      return;
    }

    setLoading(true);
    setErrorMessage('');
    
    try {
      const data = await getGruposAsesor({
        id_asesor: infoAsesor.id_asesor,
        search: busqueda || undefined
      });
      setGrupos(data.grupos || []);
      if (data.grupos?.length === 0) {
        setErrorMessage('No se encontraron grupos con los criterios de búsqueda.');
      }
    } catch (error) {
      setErrorMessage('Error al buscar grupos. Intente nuevamente.');
      setGrupos([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionar = (grupo) => {
    if (!fecha) {
      alert('Por favor seleccione una fecha');
      return;
    }
    onSeleccionarGrupo(grupo, fecha);
  };

  return (
    <div className={styles.busquedaContainer}>
      {/* Card de Búsqueda de Grupo */}
      <div className={styles.busquedaCard}>
        <div className={styles.busquedaHeader}>
          <div className={styles.busquedaIcono}>
            <span>🔍</span>
          </div>
          <h2 className={styles.busquedaTitulo}>Búsqueda de Grupo</h2>
        </div>

        {/* Filtros */}
        <div className={styles.filtrosContainer}>
          {/* Eliminado filtro de campus */}

          <div className={styles.filtroGroup}>
            <label className={styles.filtroLabel}>Fecha</label>
            <input
              type="date"
              className={styles.filtroSelect}
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
            />
          </div>
        </div>

        {/* Barra de búsqueda */}
        <div className={styles.searchBarContainer}>
          <div className={styles.searchInputWrapper}>
            <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Buscar Grupo..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleBuscar()}
            />
          </div>
          <button 
            className={styles.buscarButton}
            onClick={handleBuscar}
            disabled={loading || !infoAsesor?.id_asesor}
          >
            {loading ? 'BUSCANDO...' : 'BUSCAR'}
          </button>
        </div>

        {/* Mensaje de error o información */}
        {errorMessage && (
          <div className={styles.errorMessage}>
            {errorMessage}
          </div>
        )}

        {/* Mensaje si no hay asesor */}
        {!infoAsesor?.id_asesor && !loading && (
          <div className={styles.warningMessage}>
            ⚠️ No se detectó un asesor asociado a este usuario. Solo los asesores pueden registrar asistencias.
          </div>
        )}
      </div>

      {/* Tabla de Resultados */}
      {grupos.length > 0 && (
        <div className={styles.tablaContainer}>
          <table className={styles.tabla}>
            <thead>
              <tr className={styles.tablaHeader}>
                <th>Grupo</th>
                <th>Materia</th>
                <th>Campus</th>
                <th>Ciclo</th>
                <th>Horario</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className={styles.tablaCargando}>Cargando...</td>
                </tr>
              ) : (
                grupos.map((grupo) => (
                  <tr 
                    key={grupo.id_grupo} 
                    className={styles.tablaFila}
                    onClick={() => handleSeleccionar(grupo)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{grupo.codigo}</td>
                    <td>{grupo.nombre}</td>
                    <td>{grupo.campus}</td>
                    <td>{grupo.ciclo}</td>
                    <td>{grupo.horario}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default BusquedaGrupo;
